import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { usePermissions } from "../../contexts/PermissionsContext";

// OPUS-913: route access is permission-gated (mirrors the sidebar in LeftDrawer),
// replacing the old hard-coded role-name lists. The backend authorize() middleware
// is the real boundary — this is UX only (don't show a page a role can't use).
// Longest-prefix match; routes not listed are open to any authenticated user.
const ROUTE_PERMS = [
  ["/dashboard/user-management", "dashboard.users.view"],
  ["/dashboard/scene-management", "dashboard.scenes.view"],
  ["/dashboard/settings", "dashboard.settings.view"],
  ["/dashboard/organisation", "organisations.read"],
  ["/dashboard/organization", "organisations.read"], // tolerate either spelling
  ["/dashboard/roles", "roles.manage"],
  ["/dashboard/activity-logs", "dashboard.activity.view"],
  ["/dashboard/admin-portal", "dashboard.users.view"], // admin/super data tools; operators blocked
];

const ProtectedRoute = () => {
  const { user } = useContext(AuthContext);
  const { can, ready } = usePermissions();
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  const publicRoutes = ["/reset-password"];
  const isPublicRoute = publicRoutes.includes(location.pathname);

  if (!user && !isPublicRoute) {
    return <Navigate to="/login" replace />;
  }

  // Only enforce once permissions are resolved, so we never bounce during the
  // brief catalog load (can() is permissive until ready anyway).
  if (user && ready) {
    const match = ROUTE_PERMS.find(([prefix]) => path.startsWith(prefix));
    if (match && !can(match[1])) {
      return <Navigate to="/dashboard/renderer-management" replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;
